import useLanguage from "../../i18n/useLanguage";
import { aiFaqs } from "../../data/ai-service";

export default function AiFaq() {
  const { t } = useLanguage();
  return (
    <section aria-labelledby="ai-faq" className="py-14">
      <h2 id="ai-faq" className="text-3xl sm:text-4xl font-bold mb-8">{t("Sebelum kamu pesan")}</h2>
      <div className="space-y-3">{aiFaqs.map(item => <details key={item.question} className="rounded-xl border border-white/10 p-5 open:border-amber-300/40"><summary className="cursor-pointer font-semibold text-lg">{t(item.question)}</summary><p className="mt-4 text-gray-400 leading-relaxed">{t(item.answer)}</p></details>)}</div>
    </section>
  );
}
